import { Pipe, PipeTransform } from '@angular/core';
import { GridFormatService } from "../services";

@Pipe({
    name: "gridNumber",
    standalone: false
})
export class GridNumberPipe implements PipeTransform
{
    constructor(
        private $gridFormatService: GridFormatService
    ) {}

    transform(value: any, column: any, percent: boolean): string
    {
        if(column.DataType === "nonDelineatedNumber")
        {
            return this.$gridFormatService.nonDelineatedNumberFormatter(value, column);
        }
        else
        {
            return this.$gridFormatService.numberFormatter(value, column, percent);
        }
    }
}
